import * as React from "react";
import { cn } from "../../lib/utils";

export interface TypographyProps extends React.HTMLAttributes<HTMLElement> {
  variant?:
    | "h1"
    | "h2"
    | "h3"
    | "h4"
    | "h5"
    | "h6"
    | "p"
    | "span"
    | "caption"
    | "label";
  as?: React.ElementType;
  children: React.ReactNode;
}

const typographyVariants = {
  h1: "text-4xl font-bold text-gray-900 leading-tight",
  h2: "text-2xl font-semibold text-brand-primary leading-tight",
  h3: "text-lg font-semibold text-gray-900 leading-tight",
  h4: "text-base font-semibold text-gray-900 leading-tight",
  h5: "text-sm font-semibold text-gray-900 leading-tight",
  h6: "text-xs font-semibold text-gray-900 leading-tight",
  p: "text-base text-gray-700 leading-relaxed",
  span: "text-base text-gray-700",
  caption: "text-sm text-gray-600",
  label: "text-sm font-medium text-gray-700",
};

const Typography = React.forwardRef<HTMLElement, TypographyProps>(
  ({ variant = "p", as, className, children, ...props }, ref) => {
    const Component = as || variant;

    return (
      <Component
        ref={ref}
        className={cn(typographyVariants[variant], className)}
        {...props}
      >
        {children}
      </Component>
    );
  }
);

Typography.displayName = "Typography";

export { Typography };
